export default __webpack_public_path__ + "static/media/min-tur-white.c33e809c.svg";